import type { SVGProps } from 'react';

const SvgIpAddress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 3c-3.86 0-7 3.14-7 7 0 5.41 6.1 10.55 6.36 10.77a1.005 1.005 0 0 0 1.28 0C12.9 20.55 19 15.41 19 10c0-3.86-3.14-7-7-7m0 15.65c-1.48-1.4-5-5.1-5-8.65 0-2.76 2.24-5 5-5s5 2.24 5 5c0 3.55-3.52 7.25-5 8.65"
    />
    <path
      fill="currentcolor"
      d="M10.345 7.176a.71.71 0 0 0-.933 0 .6.6 0 0 0-.192.445v4.76a.56.56 0 0 0 .183.436q.188.181.475.183a.68.68 0 0 0 .467-.175.59.59 0 0 0 .208-.445V7.62a.58.58 0 0 0-.2-.444zm4.255.094a1.57 1.57 0 0 0-.88-.27h-1.84a.61.61 0 0 0-.47.19c-.13.13-.19.29-.19.47v4.67c0 .18.06.34.17.47.12.13.28.2.46.2s.35-.07.47-.2a.65.65 0 0 0 .17-.47v-1.35h1.23c.31 0 .61-.09.88-.28.27-.18.49-.42.65-.72s.25-.63.25-1-.08-.71-.25-1c-.16-.3-.38-.54-.65-.72zm-.5 2.08c-.05.11-.12.21-.2.28a.28.28 0 0 1-.18.09h-1.23V8.28h1.23c.06 0 .12.03.19.08a.86.86 0 0 1 .28.63c0 .13-.03.24-.08.36z"
    />
  </svg>
);
export default SvgIpAddress;
